import { buildFetchConfig } from '@/utils/fetchUtils';

export type AdpContext = {
  hub_id?: string;
  project_id?: string;
  team_id?: string;
  account_tier: string;
  region?: string;
};

type UserContextResponse = {
  accessible_tenants: Array<{
    tenant_id: string;
    tenant_name: string;
    is_default: boolean;
  }>;
  default_tenant_id?: string;
  adp_context?: AdpContext;
};

export const fetchUserContext = async (): Promise<UserContextResponse> => {
  const { baseURL, headers } = buildFetchConfig();
  const response = await fetch(`${baseURL}/w3f/user/context`, { headers });

  if (!response.ok) {
    throw new Error(`Failed to fetch user context: ${response.status}`);
  }

  return response.json();
};
